import React from "react";
import { Helmet } from "react-helmet";
import { isEmptyContentfulEntry } from "@helpers";

const ContentfulPageSEO = ({ meta }) => {
  const title = meta && meta.title;

  return (
    <>
      {meta && (
        <Helmet title={isEmptyContentfulEntry(title) ? "" : title}>
          {!isEmptyContentfulEntry(meta.author && meta.author) && (
            <meta name="author" content={meta.author} />
          )}
          {!isEmptyContentfulEntry(
            meta.description &&
              meta.description.description &&
              meta.description.description
          ) && (
            <meta name="description" content={meta.description.description} />
          )}
          {!isEmptyContentfulEntry(
            meta.keywords && meta.keywords.keywords && meta.keywords.keywords
          ) && <meta name="keywords" content={meta.keywords.keywords} />}

          {!isEmptyContentfulEntry(meta.ogtitle && meta.ogtitle) && (
            <meta property="og:title" content={meta.ogtitle} />
          )}
          {!isEmptyContentfulEntry(
            meta.ogdescription &&
              meta.ogdescription.ogdescription &&
              meta.ogdescription.ogdescription
          ) && (
            <meta
              property="og:description"
              content={meta.ogdescription.ogdescription}
            />
          )}
          {!isEmptyContentfulEntry(
            meta.ogurl && meta.ogurl.ogurl && meta.ogurl.ogurl
          ) && <meta property="og:url" content={meta.ogurl.ogurl} />}
          {!isEmptyContentfulEntry(meta.oglocale && meta.oglocale) && (
            <meta property="og:locale" content={meta.oglocale} />
          )}
          {!isEmptyContentfulEntry(
            meta.ogimageMedia?.localFile?.url || meta.ogimage?.ogimage
          ) && (
            <meta
              property="og:image"
              content={
                meta.ogimageMedia?.localFile?.url || meta.ogimage?.ogimage
              }
            />
          )}
          {!isEmptyContentfulEntry(meta.ogtype && meta.ogtype) && (
            <meta property="og:type" content={meta.ogtype} />
          )}
        </Helmet>
      )}
    </>
  );
};

export default ContentfulPageSEO;
